export default "__VITE_ASSET__DPpF3DVw__"